import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `${ctx.brand} 中文首页`,
    languageButtonLabel: `语言`,
    languageModalTitle: `选择语言`,
    languageModalCloseLabel: `关闭语言菜单`,
  },
  languageOptions: {
    'en-US': {
      label: `英语`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `英语（肯尼亚）`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `英语（尼日利亚）`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `英语 (新加坡)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `葡萄牙语`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `德语`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `西班牙语`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `法语`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `意大利语`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `荷兰语`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `北欧与波罗的海语`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `日语`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `韩语`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `普通话`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `粤语`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `泰语`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `印地语`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `波斯语`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `俄语`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `阿拉伯语`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `摩洛哥阿拉伯语`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `选择语言`,
    closeLabel: `关闭语言菜单`,
  },
  languageHint: (ctx) => `一键切换 ${ctx.localesCount}+ 种语言。`,
  readPagePrompt: ({languageLabel}) => `用${languageLabel}阅读此页面。`,
};
